<template>
    <div class="dialog_center">
        <div class='message_bar'>
            <span>
                <img src='https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/img/icon/message.png'>
                消息：已发送
            </span>
            <span>
                <img src='https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/img/icon/news.png'>
                短信：已发送

            </span>

        </div>
        <div class='device_detail' v-if='productType=="2"||productType=="4"?true:false'>
            <div>
                <div style="color: #e89e41; font-size: 20px; text-align: center;font-weight: bold;line-height: 45px;">{{dialog_data.alarmType}}</div>
            </div>
            <deviceList :deviceDataList =device_data></deviceList>
        </div>
        <div class='civilian_device_detail' v-if='productType=="1"?true:false'>
            <div class="pics_group">
            <!-- <el-carousel :interval="4000" arrow="always">
                <el-carousel-item v-for="(item,index) in dialogData.infodata.pic" :key="item.name+index">
                        <h4 style="color: #909399;position: absolute;">{{item.name}}</h4>
                        <el-image style="width: 100%; height: 100%" fit="contain" :src="item.url" :preview-src-list="srcList">></el-image>

                </el-carousel-item>
            </el-carousel> -->
           <el-row :gutter="4">
          <el-col
            :span="8"
             v-for="(item, index) in dialogData.infodata.pic"
            :key="index"
            class="grid-content bg-purple"
          >
            <div style="position: relative;height:200px;">

                <el-image style="width: 100%; height: 100%" fit="cover" :src="item.url" :preview-src-list="srcList"></el-image>

                <span class="item_span_type">{{item.name}}</span>

            </div>
          </el-col>
        </el-row>

            </div>
            <div class='civilian_alarmMes'>
                <span>{{dialogData.alarminfo.alarmName}}</span>
                <span>{{dialogData.alarminfo.time}}</span>
            </div>
        </div>
        <div class='civilian_device_detail' v-if='productType=="3"?true:false'>
            <div class="pics_group">
            <el-carousel :interval="4000" arrow="always">
                <el-carousel-item v-for="(item,index) in dialogData.infodata.pic" :key="item.name+index">
                        <h4 style="color: #909399;position: absolute;">{{item.name}}</h4>
                        <el-image style="width: 100%; height: 100%" :src="item.url" :preview-src-list="srcList">></el-image>

                </el-carousel-item>
            </el-carousel>
            </div>
            <div class='industrial_alarmMes'>
                <span>{{dialogData.alarminfo.alarmName}}</span>
                <span>{{dialogData.alarminfo.time}}</span>
            </div>
          
        </div>

        <div class="qiehuan">
            <el-link icon="el-icon-user-solid" style="color:skyblue;" @click="qiehuanClick(0)">基础信息</el-link>
            <el-link style="color:skyblue;" @click="qiehuanClick(1)"><i class="el-icon-sunrise-1"></i>配件信息</el-link>
            <el-link style="color:skyblue;" @click="qiehuanClick(2)"><i class="el-icon-position"></i>地理位置 </el-link>

        </div>
        <div class='content_detail'>
              
            <div class="detai_box">
              <el-row :gutter="24">
                    <el-col v-show="lodeg_isbool" :span="10" v-for="(item,index) in dialogData.infodata.info" :key="item.key+item.value"><span class='dian'></span>{{item.key}}：{{item.value}}</el-col>
                    <el-col v-show="!lodeg_isbool" :span="10" v-for="(item,index) in dialogData.infodata.peri" :key="item.key+item.value"><span class='dian'></span>{{item.key}}：{{item.value}}</el-col>

                </el-row>
            </div>

        </div>

    </div>
</template>

<script>
    import {mapState, mapMutations} from 'vuex'
    import deviceList from './device_list'

    export default {
        name: 'dialog_center',  
        props: {
            dialogData: {
                type: Object,
                default: () => {
                }
            },
            productType: {
                type: Number,
                default: ''
            }
        },
        components:{
            deviceList
        },
        data () {
            return {
                lodeg_isbool:true,
                dialog_data: {},
                srcList: [],
                video_item_array: []

            }
        },
        mounted () {
                  
                  
        },
        watch: {
            dialogData: {
                

                handler: function (newVal, oldVal) {
                    this.dialogData.infodata.pic.filter((item, i) => {
                      this.srcList.push(item.url)
                  })
                },
                deep: true
            },
           
        },
        computed: {

        },
        methods: {
            mappush(){
                 
            var marker = new AMap.Marker({
                position:this.dialogData.infodata.position,
              
            })
               marker.markOnAMAP({
                        name:this.dialogData.alarminfo.deviceName,  //地理位置名称
                        position: marker.getPosition()
               })
            },
            qiehuanClick(tag){
                console.log('数据触发内容-=-=-=-'+tag)
               
                switch (tag) {
                    case 0:
                        this.lodeg_isbool = true                       
                        break;
                    case 1:
                        this.lodeg_isbool = false                      
                        break;
                    case 2:
                        this.mappush()
                        break;
                
                    default:
                        break;
                }
            }

          
        }
    }
</script>
<style scoped lang='less'>
    .dialog_center {
        position: relative;
        width: 80%;
        height: 100%;
        .message_bar {
            //  position: relative;
            // width: 100%;
        // height: 100%;
            text-align: left;

            & > span {
                margin-left: 22px;
                color: #ffffff;
                font-size: 12px;

                img {
                    vertical-align: middle;
                }

            }
        }

        .device_detail {
            height:100%;
            width: 100%;
            // background: url(https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/img/device_bg.png) no-repeat;
            // background-position: 100% 100%;
            // background-size:100%;
            margin-top: 3%;
            position: relative;
            background-color: blue;
 

        }

        .civilian_device_detail {
            height: 420px;
            // background:url(../../../static/img/device_bg.png) no-repeat;
            background-position: -15% 100%;
            margin-top: 0px;
            position: relative;
            text-align: left;
            .pics_group{
                padding: 10px 0 0 0;
                position: absolute;
                width: 100%;
                height: 100%;
                top: 12%;
                background-color: rgba(23, 148, 231, 0.3);
                overflow:auto;
                overflow-x: hidden;
                overflow-y: scroll;


            }
            img {
                width: 100%;
                height: 50%;
            }

            .mes {
                width: 105px;
                height: 75px;
                line-height: 30px;
                text-align: center;
                color: black;
                font-weight: bold;
                background: url(https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/img/mesbox.png) no-repeat;
                background-size: 100% 100%;
                position: absolute;
                top: 65px;
                left: 150px;
                z-index: 20;
            }
        }
& /deep/   .el-carousel__container {
    position: relative;
    width: 97%;
    left: 10px;
    right: 10px;
    }
        .qiehuan{
            position: relative;
            margin-top: 10%;
        }
        .content_detail {
            width: 100%;
            height: 80%;
            color: #ffffff;
            font-size: 12px;
            margin-top: 1%;
            
           .detai_box {
                background: url(https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/img/detail_bottom.png) no-repeat;
                background-size: 100% 100%;
                padding: 20px 0 0 0px;
                position: absolute;
                width: 100%;
                height: 29%;
                .el-col{
                        margin-top:1.5%;
                        margin-left:2%;
                }
             

                .dian {
                    display: inline-block;
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                    background: #08d320;
                    margin-right: 10px;

                }
            }

        }

        .inpresgifWrapper {
            text-align: center;
            margin: 0 auto;
            width: 482px;
            height: 28px;
            position: absolute;
            top: 57%;
            left: 50%;
            margin-top: -14px;
            margin-left: -241px;
            display: flex;
            justify-content: space-between;

            img {
                width: 40px;
                height: 20px;
                margin-top: 5px;
            }
        }

        .alarmMes, .civilian_alarmMes, .industrial_alarmMes {
            position: absolute;
            top: 20px;
            margin-left: 0px;
            color: #fff;
            font-size: 12px;
            text-align: left;
            z-index: 10;

            & > span:nth-child(1) {
                margin-right: 10px;
            }
        }
        .item_span_type{
          font-size: 12px;
          color: #FFFFFF;
          position: absolute;
          top: 0; left: 0;
          background-color: rgb(34, 37, 199);
          
        }
      
    }
</style>



// WEBPACK FOOTER //
// src/components/dialog/dialog_center.vue